/* istanbul ignore file */
import { highContrastFocus, minBreakpoints } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import {
  FAVOURITE_ICON_TRANISITION_DURATION_IN_MS,
  FAVOURITE_TRANSITION_CLASSNAME,
} from './constants/favouriteButton';
import { BUTTON__CONTENT_CLASS } from 'client-ribbons-design-system';
import {
  FAVOURITE_LARGE_PRESS_SIZE,
  FAVOURITE_LARGE_SIZE,
  FAVOURITE_SMALL_PRESS_SIZE,
  FAVOURITE_SMALL_SIZE,
} from 'client-ribbons-design-system/styles/button';

export const small = css`
  width: ${pxToRem(FAVOURITE_SMALL_SIZE)};
  height: ${pxToRem(FAVOURITE_SMALL_SIZE)};
  background: var(--neutral-white-base);
  border: solid ${pxToRem(1)} var(--brand-purple-base) !important;

  &:active {
    transform: scale(${FAVOURITE_SMALL_PRESS_SIZE / FAVOURITE_SMALL_SIZE});
  }
`;

export const large = css`
  width: ${pxToRem(FAVOURITE_LARGE_SIZE)};
  height: ${pxToRem(FAVOURITE_LARGE_SIZE)};
  background: var(--neutral-white-base);
  border: solid ${pxToRem(1)} var(--brand-purple-base) !important;

  &:active {
    transform: scale(${FAVOURITE_LARGE_PRESS_SIZE / FAVOURITE_LARGE_SIZE});
  }

  &.focus-visible:focus {
    border: solid ${pxToRem(1)} var(--brand-purple-base) !important;
  }
`;

export const favouriteIconTransition = css`
  .${FAVOURITE_TRANSITION_CLASSNAME}-enter {
    opacity: 0;
    transition: opacity ${FAVOURITE_ICON_TRANISITION_DURATION_IN_MS}ms;
  }
  .${FAVOURITE_TRANSITION_CLASSNAME}-exit {
    opacity: 1;
    transition: opacity ${FAVOURITE_ICON_TRANISITION_DURATION_IN_MS}ms;
  }
  .${FAVOURITE_TRANSITION_CLASSNAME}-enter-active {
    opacity: 1;
    transition: opacity ${FAVOURITE_ICON_TRANISITION_DURATION_IN_MS}ms;
  }
  .${FAVOURITE_TRANSITION_CLASSNAME}-exit-active {
    opacity: 0;
    transition: opacity ${FAVOURITE_ICON_TRANISITION_DURATION_IN_MS}ms;
  }
`;

export const favouriteButton = css`
  cursor: pointer;
  position: absolute;
  border-radius: 50%;
  padding: 0;

  .${BUTTON__CONTENT_CLASS} {
    display: flex;
    justify-content: center;
  }

  &.focus-visible:focus {
    ${highContrastFocus}
  }

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      padding: 0;
    `,
  )};
`;
